module.exports = __webpack_public_path__ + "img/symbol_9.6ca65580.png";